import { SBCFlex } from '../../../components/QnaPage/QuestionWrapper/styled';
import { images } from '../../../Constants/ImageUrls';
import { callCustomerCare } from '../../../Utils/redirections';
import { FlexCenter } from '../../ArticlePage/Info/styled';
import { Pinkrightarrow } from '../../ArticlePage/RelatedArticles/styled';
import { RefundContainer, Title } from '../Refund/styled';

export default function index() {
  return (
    <RefundContainer cancel>
      <div>
        <img src="/images/customer-care.png" alt="" />
      </div>
      <Title refundhelp padding="10px 0 6px">
        Need any help with return &amp; cancellations
      </Title>
      {/* <ContactRefund>Contact our 24 X 7 Support</ContactRefund> */}
      <SBCFlex>
        <Title
          refundhelp
          refundcolor="#ef4e5e"
          padding="10px 0 6px"
          onClick={callCustomerCare}
        >
          <FlexCenter>
            <p> Call Us </p>
            <Pinkrightarrow left src={images.pinkrightarrow} alt="" small />
          </FlexCenter>
        </Title>
      </SBCFlex>
    </RefundContainer>
  );
}
